import watchGetMessageDataRequested from './GetMessagesSaga';
import watchGetMessageDataReadRequested from './GetMessagesReadSaga';

export default [
  watchGetMessageDataRequested(),
  watchGetMessageDataReadRequested(),
];
